function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// Функция для установки кросс-доменного cookie
function setCrossDomainCookie(name, value, domain) {
  // Устанавливаем значения для cookie
  var cookieValue = name + "=" + encodeURIComponent(value) + ";";

  // Добавляем атрибут domain для кросс-доменности
  // cookieValue += "domain=" + domain + ";";

  // Устанавливаем путь cookie
  cookieValue += "path=/;";

  // Добавляем атрибуты secure и SameSite=None для отправки cookie при кросс-доменных запросах
  cookieValue += `secure;SameSite=None;max-age=${60 * 60 * 24 * 365}`;

  // Устанавливаем cookie
  document.cookie = cookieValue;
}

export function priemTimeline() {
  const buttons = document.querySelectorAll('[data-priem-timeline-action]');
  if (buttons.length === 0) return;

  const allContents = document.querySelectorAll('[data-priem-timeline]');

  // Прочитать сохранённое значение из cookie
  const savedAction = getCookie('priemTimelineActive') || 'bachelors';

  // Функция прячет элемент с анимацией
  function hideContent(el) {
    if (el.classList.contains('d-none')) return Promise.resolve();
    const animation = el.animate(
      [
        { opacity: 1, transform: 'translateY(0px)' },
        { opacity: 0, transform: 'translateY(10px)' }
      ],
      { duration: 200, easing: 'ease' }
    );
    return animation.finished.then(() => {
      el.classList.add('d-none');
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  // Функция показывает элемент с анимацией
  function showContent(el) {
    el.classList.remove('d-none');
    el.style.opacity = 0;
    el.style.transform = 'translateY(-10px)';
    const animation = el.animate(
      [
        { opacity: 0, transform: 'translateY(-10px)' },
        { opacity: 1, transform: 'translateY(0px)' }
      ],
      { duration: 200, easing: 'ease' }
    );
    return animation.finished.then(() => {
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  // Инициализация: если в cookie есть сохранённое действие — активируем его
  if (savedAction) {
    const initButton = document.querySelector(
      `[data-priem-timeline-action="${savedAction}"]`
    );
    const initContent = document.querySelector(
      `[data-priem-timeline="${savedAction}"]`
    );
    if (initButton && initContent) {
      initButton.classList.add('active');
      allContents.forEach(el => el.classList.add('d-none'));
      initContent.classList.remove('d-none');
    }
  }

  buttons.forEach(button => {
    const action = button.dataset.priemTimelineAction;
    const content = document.querySelector(
      `[data-priem-timeline="${action}"]`
    );
    if (!content) return;

    button.addEventListener('click', async event => {
      event.preventDefault();

      // Сбрасываем состояние всех кнопок и блоков
      buttons.forEach(btn => btn.classList.remove('active'));
      await Promise.all(Array.from(allContents).map(el => hideContent(el)));

      // Активируем выбранную кнопку
      button.classList.add('active');
      await showContent(content);

      // Сохраняем выбор в cookie на год
      setCrossDomainCookie('priemTimelineActive', action, document.domain);
    });
  });
}
